module.exports = __webpack_public_path__ + "img/upload_howitworks_ach.e2436bfc.svg";